export type ItemQuickEditField = "price_default" | "lower_limit" | "target_rank";

type LowerLimitRange = {
  value_min?: number | null;
  value_max?: number | null;
  value_min_type?: string;
  [key: string]: unknown;
};

export type ItemQuickEditData = {
  price_default: number;
  target_rank: number;
  compare_site: string;
  compare_range: string;
  compare_items_specified?: unknown;
  compare_items_direct_specified?: unknown;
  adjust_strategy: string;
  adjust_price_range: LowerLimitRange;
  adjust_discount_range: LowerLimitRange;
  adjust_price_exposed_range: LowerLimitRange & { is_enabled?: boolean };
};

export const getItemLowerLimit = (item: ItemQuickEditData) => {
  if (item.adjust_price_exposed_range.is_enabled) {
    return { field: "adjust_price_exposed_range" as const, label: "노출가 하한", range: item.adjust_price_exposed_range };
  }
  if (item.adjust_strategy === "adjust_price" || item.adjust_strategy === "adjust_price_match_discount") {
    return { field: "adjust_price_range" as const, label: "판매가 하한", range: item.adjust_price_range };
  }
  return { field: "adjust_discount_range" as const, label: "할인액 하한", range: item.adjust_discount_range };
};

export const getItemTargetRankMax = (item: ItemQuickEditData) => {
  if (item.compare_range !== "items_specified") return 3;
  const specified = item.compare_site === "direct"
    ? item.compare_items_direct_specified
    : item.compare_items_specified;
  if (Array.isArray(specified)) return Math.min(3, specified.length);
  if (typeof specified === "string") {
    try {
      const parsed = JSON.parse(specified);
      return Array.isArray(parsed) ? Math.min(3, parsed.length) : 0;
    } catch {
      return 0;
    }
  }
  return 0;
};

export const buildItemQuickEditPayload = (item: ItemQuickEditData, field: ItemQuickEditField, value: number) => {
  if (field === "lower_limit") {
    const lowerLimit = getItemLowerLimit(item);
    return { [lowerLimit.field]: { ...lowerLimit.range, value_min: value } };
  }
  return { [field]: value };
};
